import { jsx, jsxs } from "react/jsx-runtime";
const IconHome = ({ size = 20, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12 2.09998L1 12H4V21H11V15H13V21H20V12H23L12 2.09998ZM18 19H15V13H9V19H6V10.19L12 4.68998L18 10.19V19Z",
        fill: "currentColor"
      }
    )
  }
);
const IconSidebar = ({ size = 24, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: Math.round(size * 20 / 24),
    viewBox: "0 0 24 20",
    fill: "none",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M4.07715 0.0996094H19.9229C20.9788 0.0996279 21.9907 0.504276 22.7363 1.22266C23.4818 1.94096 23.9004 2.91453 23.9004 3.92871V16.0713C23.9004 17.0855 23.4818 18.059 22.7363 18.7773C21.9907 19.4957 20.9788 19.9004 19.9229 19.9004H4.07715C3.0212 19.9004 2.00926 19.4957 1.26367 18.7773C0.518186 18.059 0.0996094 17.0855 0.0996094 16.0713V3.92871C0.0996094 2.91453 0.518186 1.94096 1.26367 1.22266C2.00926 0.504276 3.0212 0.0996276 4.07715 0.0996094ZM4.07715 2.04297C3.56031 2.04299 3.06382 2.24056 2.69727 2.59375C2.33057 2.94708 2.12402 3.42736 2.12402 3.92871V16.0713C2.12402 16.5726 2.33057 17.0529 2.69727 17.4062C3.06382 17.7594 3.56031 17.957 4.07715 17.957H6.03027V2.04297H4.07715ZM8.05469 17.957H19.9229C20.4397 17.957 20.9362 17.7594 21.3027 17.4062C21.6694 17.0529 21.876 16.5726 21.876 16.0713V3.92871C21.876 3.42736 21.6694 2.94708 21.3027 2.59375C20.9362 2.24056 20.4397 2.04299 19.9229 2.04297H8.05469V17.957Z",
        fill: "currentColor"
      }
    )
  }
);
const IconCompose = ({ size = 20, className, style }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M5.95216 19.6877C5.99369 19.6794 6.03672 19.6865 6.07357 19.7074C7.55917 20.5512 9.24531 21 11 21C13.4663 21 15.7971 20.1133 17.6265 18.4899C17.7783 18.3552 17.9265 18.2154 18.071 18.071C19.96 16.1824 21 13.6713 21 11C21 8.32909 19.96 5.81806 18.071 3.92901C16.1966 2.05461 13.6654 1.00374 11.0146 1.00001C8.33826 0.996234 5.821 2.03706 3.92905 3.92901C3.78461 4.07349 3.64481 4.22167 3.51012 4.37358C1.88672 6.20337 1 8.53366 1 11C1 12.8347 1.49071 14.5937 2.41 16.1274C2.43403 16.1675 2.44137 16.2153 2.43 16.2606L1.60577 19.5527C1.54751 19.7857 1.61324 20.0322 1.77909 20.206C1.91237 20.3449 2.10817 20.4713 2.45494 20.3876L5.95216 19.6877Z",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M8.44141 11.0098H13.5451", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
      /* @__PURE__ */ jsx("path", { d: "M11.0039 8.44531V13.549", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" })
    ]
  }
);
const IconImageUpload = ({ size = 24, className, style }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M15.342 23.9893H8.64729C2.58861 23.9893 0 21.4007 0 15.342V8.64729C0 2.58861 2.58861 0 8.64729 0H15.342C21.4007 0 23.9893 2.58861 23.9893 8.64729V15.342C23.9893 21.4007 21.4007 23.9893 15.342 23.9893ZM8.64729 1.67367C3.50355 1.67367 1.67367 3.50355 1.67367 8.64729V15.342C1.67367 20.4857 3.50355 22.3156 8.64729 22.3156H15.342C20.4857 22.3156 22.3156 20.4857 22.3156 15.342V8.64729C22.3156 3.50355 20.4857 1.67367 15.342 1.67367H8.64729Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M8.64728 10.5999C6.9513 10.5999 5.57889 9.2275 5.57889 7.53151C5.57889 5.83553 6.9513 4.46312 8.64728 4.46312C10.3433 4.46312 11.7157 5.83553 11.7157 7.53151C11.7157 9.2275 10.3433 10.5999 8.64728 10.5999ZM8.64728 6.13679C7.8774 6.13679 7.25256 6.76162 7.25256 7.53151C7.25256 8.3014 7.8774 8.92624 8.64728 8.92624C9.41717 8.92624 10.042 8.3014 10.042 7.53151C10.042 6.76162 9.41717 6.13679 8.64728 6.13679Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.58414 20.5863C1.31636 20.5863 1.04857 20.4524 0.892361 20.218C0.635731 19.8387 0.736151 19.3143 1.12667 19.0576L6.62747 15.3644C7.83251 14.5499 9.49502 14.6503 10.5885 15.5764L10.9567 15.9C11.5146 16.3798 12.463 16.3798 13.0098 15.9L17.6514 11.9166C18.8341 10.9013 20.6975 10.9013 21.8914 11.9166L23.7101 13.4787C24.056 13.78 24.1006 14.3044 23.7994 14.6615C23.4981 15.0074 22.9737 15.052 22.6166 14.7507L20.7979 13.1886C20.24 12.7088 19.2916 12.7088 18.7337 13.1886L14.0921 17.172C12.9093 18.1873 11.046 18.1873 9.85211 17.172L9.48387 16.8484C8.97061 16.4132 8.12261 16.3686 7.55357 16.7591L2.05277 20.4524C1.90772 20.5416 1.74035 20.5863 1.58414 20.5863Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
const IconMicrophone = ({
  size = 17,
  height = 24,
  className,
  style
}) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M8.5 17.1429C5.68778 17.1429 3.4 14.8359 3.4 12V5.14286C3.4 2.307 5.68778 0 8.5 0C11.3122 0 13.6 2.307 13.6 5.14286V12C13.6 14.8359 11.3122 17.1429 8.5 17.1429ZM8.5 1.71429C6.62533 1.71429 5.1 3.25243 5.1 5.14286V12C5.1 13.8904 6.62533 15.4286 8.5 15.4286C10.3747 15.4286 11.9 13.8904 11.9 12V5.14286C11.9 3.25243 10.3747 1.71429 8.5 1.71429ZM16.15 10.2857C15.6806 10.2857 15.3 10.6695 15.3 11.1429V12C15.3 15.7811 12.2496 18.8571 8.5 18.8571C4.75044 18.8571 1.7 15.7811 1.7 12V11.1429C1.7 10.6695 1.31941 10.2857 0.85 10.2857C0.380587 10.2857 0 10.6695 0 11.1429V12C0 16.4372 3.36069 20.0966 7.65 20.5279V22.2857H5.95C5.48059 22.2857 5.1 22.6695 5.1 23.1429C5.1 23.6162 5.48059 24 5.95 24H11.05C11.5194 24 11.9 23.6162 11.9 23.1429C11.9 22.6695 11.5194 22.2857 11.05 22.2857H9.35V20.5279C13.6393 20.0964 17 16.437 17 12V11.1429C17 10.6695 16.6194 10.2857 16.15 10.2857Z",
        fill: "currentColor"
      }
    )
  }
);
const IconArrowRight = ({ size = 12, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size * 9 / 12,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.1231 4.03711C11.1229 4.03695 11.1228 4.03675 11.1226 4.03659L8.22563 1.16103C8.0086 0.945614 7.65757 0.946414 7.44154 1.1629C7.22553 1.37938 7.22637 1.72952 7.44339 1.94495L9.38841 3.87559H1.55442C1.24822 3.87559 1 4.12315 1 4.42858C1 4.734 1.24822 4.98161 1.55442 4.98161H9.38839L7.44344 6.9122C7.22641 7.12765 7.22557 7.47776 7.44158 7.69423C7.6576 7.91075 8.00867 7.91151 8.22567 7.69612L11.1226 4.82053C11.1228 4.82037 11.1229 4.82017 11.1231 4.82C11.3403 4.60386 11.3396 4.25257 11.1231 4.03712L11.1231 4.03711Z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: "0.428571"
      }
    )
  }
);
const IconHamburger = ({ size = 32, className, style }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M6 10h12", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
      /* @__PURE__ */ jsx("path", { d: "M6 16h20", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
      /* @__PURE__ */ jsx("path", { d: "M6 22h16", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" })
    ]
  }
);
const IconChats = ({ size = 20, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M20.2796 16.1373L19.118 12.7029C19.6779 11.5401 19.9738 10.2468 19.9758 8.94564C19.9792 6.68311 19.1176 4.54385 17.5495 2.92195C15.9812 1.29973 13.8912 0.386554 11.6647 0.35072C9.35587 0.313654 7.18572 1.20584 5.55419 2.86329C3.98099 4.4615 3.10841 6.56846 3.08079 8.81999C1.53024 10.006 0.615044 11.8551 0.618052 13.8301C0.619497 14.7544 0.824263 15.6731 1.21227 16.5039L0.412153 18.8694C0.274614 19.2761 0.375083 19.7176 0.67438 20.0217C0.885006 20.2357 1.1627 20.3496 1.44829 20.3496C1.56844 20.3496 1.69001 20.3295 1.80856 20.2881L4.13704 19.4752C4.95481 19.8694 5.85915 20.0774 6.76892 20.0789C6.7722 20.0789 6.77532 20.0789 6.77861 20.0789C8.75165 20.0788 10.5856 19.1251 11.7488 17.5112C12.9592 17.4788 14.1569 17.1812 15.2396 16.6431L18.6202 17.8232C18.761 17.8724 18.9055 17.8964 19.0483 17.8964C19.3876 17.8964 19.7176 17.761 19.968 17.5066C20.3236 17.1453 20.443 16.6206 20.2796 16.1373ZM6.77853 18.8695C6.77599 18.8695 6.77329 18.8695 6.77075 18.8695C5.96552 18.8682 5.16587 18.6666 4.45841 18.2863C4.31294 18.2082 4.14216 18.1946 3.98661 18.2489L1.59899 19.0824L2.41942 16.6568C2.47286 16.4988 2.45958 16.3253 2.38262 16.1775C2.00833 15.4588 1.80981 14.6464 1.80856 13.8283C1.80657 12.5124 2.31044 11.2652 3.19157 10.3313C3.47938 12.1137 4.3156 13.7563 5.61177 15.0496C6.89837 16.3335 8.51564 17.1509 10.2606 17.4181C9.33923 18.3407 8.0972 18.8695 6.77853 18.8695ZM19.1261 16.6514C19.0923 16.6858 19.0521 16.6952 19.0069 16.6794L15.3879 15.416C15.325 15.394 15.2596 15.3832 15.1945 15.3832C15.0984 15.3832 15.0027 15.4068 14.9161 15.4534C13.8828 16.0087 12.7151 16.3032 11.5393 16.3051C11.5354 16.3051 11.5319 16.3051 11.528 16.3051C7.58806 16.3051 4.33364 13.0536 4.27122 9.05183C4.23978 7.03646 4.99439 5.14237 6.39599 3.71845C7.79759 2.29454 9.66232 1.52819 11.6458 1.55994C15.5887 1.62348 18.7914 4.93581 18.7853 8.94373C18.7835 10.1383 18.4936 11.3246 17.947 12.3743C17.87 12.522 17.8567 12.6955 17.9102 12.8536L19.1537 16.5303C19.1692 16.5763 19.1599 16.6171 19.1261 16.6514Z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: "0.7"
      }
    )
  }
);
const IconChevronUp = ({ size = 24, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M18 15l-6-6-6 6",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
);
const IconClose = ({ size = 20, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx("path", { d: "M15.5 4.5L4.5 15.5M4.5 4.5l11 11", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
  }
);
const IconSearch = ({ size = 16, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M15.8178 14.9381L11.913 11.0334C12.8836 9.86621 13.4683 8.36744 13.4683 6.73438C13.4683 3.02103 10.4474 0 6.73421 0C3.02094 0 0 3.02103 0 6.73438C0 10.4475 3.02094 13.4683 6.73421 13.4683C8.36719 13.4683 9.86605 12.8836 11.0332 11.913L14.9381 15.8178C15.0595 15.9393 15.2188 16 15.3779 16C15.5371 16 15.6963 15.9393 15.8179 15.8178C16.0608 15.5748 16.0608 15.181 15.8178 14.9381ZM1.24414 6.73438C1.24414 3.70705 3.70696 1.24414 6.73421 1.24414C9.76137 1.24414 12.2241 3.70705 12.2241 6.73438C12.2241 9.76146 9.76137 12.2241 6.73421 12.2241C3.70696 12.2241 1.24414 9.76146 1.24414 6.73438Z",
        fill: "currentColor"
      }
    )
  }
);
const IconTrash = ({ size = 18, className, style }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: size,
    height: size * 15.1 / 12.1,
    viewBox: "0 0 12.1 15.1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.44965 4.66556C1.77024 4.67332 2.0238 4.93783 2.01598 5.25636L1.43551 5.24231C0.855035 5.22826 0.855035 5.22826 0.855035 5.22826L0.854262 5.26106L0.85217 5.35429C0.850407 5.43533 0.84797 5.55294 0.845255 5.69963C0.83984 5.99297 0.833345 6.40288 0.82901 6.86938C0.82037 7.79975 0.820235 8.96488 0.855282 9.87965C0.89363 10.8802 0.996852 12.1752 1.08202 13.1395C1.17822 14.2286 2.09883 15.05 3.19023 15.05H8.90975C10.0011 15.05 10.9218 14.2286 11.018 13.1395C11.1031 12.1752 11.2064 10.8802 11.2447 9.87965C11.2797 8.96488 11.2796 7.79975 11.271 6.86938C11.2666 6.40288 11.2602 5.99297 11.2548 5.69963C11.252 5.55294 11.2496 5.43533 11.2478 5.35429L11.2458 5.26106L11.2449 5.22887C11.2371 4.91033 10.9709 4.6578 10.6503 4.66556C10.3297 4.67332 10.0762 4.93783 10.084 5.25636L10.0848 5.28766L10.0868 5.37924C10.0885 5.45915 10.091 5.57549 10.0936 5.7208C10.099 6.01147 10.1055 6.41773 10.1097 6.88003C10.1184 7.80703 10.1182 8.94958 10.0842 9.83578C10.0471 10.8059 9.9461 12.0769 9.86112 13.0387C9.81837 13.5231 9.40805 13.8961 8.90975 13.8961H3.19023C2.69193 13.8961 2.28165 13.5231 2.23887 13.0387C2.15391 12.0769 2.05291 10.8059 2.01573 9.83578C1.98177 8.94958 1.98164 7.80703 1.99025 6.88003C1.99455 6.41773 2.00099 6.01147 2.00635 5.7208C2.00904 5.57549 2.01145 5.45915 2.01319 5.37924L2.01524 5.28766L2.01598 5.25636L1.43551 5.24231Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.05 2.93461C0.05 2.61599 0.309965 2.35769 0.630642 2.35769H11.4693C11.79 2.35769 12.05 2.61599 12.05 2.93461C12.05 3.25324 11.79 3.51154 11.4693 3.51154H0.630642C0.309965 3.51154 0.05 3.25324 0.05 2.93461Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.24241 1.16991C3.61243 0.480583 4.33469 0.05 5.12098 0.05H6.97903C7.76533 0.05 8.48757 0.480583 8.85762 1.16991L9.65907 2.66312C9.81005 2.94426 9.70295 3.29373 9.42005 3.44367C9.13708 3.59361 8.78533 3.48725 8.63443 3.20611L7.8329 1.71289C7.66475 1.39956 7.3364 1.20385 6.97903 1.20385H5.12098C4.7636 1.20385 4.43527 1.39956 4.26708 1.71289L3.46556 3.20611C3.31465 3.48725 2.96293 3.59361 2.67998 3.44367C2.39703 3.29373 2.28998 2.94426 2.4409 2.66312L3.24241 1.16991Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
const IconShareChat = ({ size = 24, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M7.1478e-07 9.99805V9.83203C7.1478e-07 9.46476 0.29777 9.16699 0.66504 9.16699C1.03231 9.16699 1.33008 9.46476 1.33008 9.83203V9.99805C1.33008 10.7089 1.33099 11.2025 1.36231 11.5859C1.39299 11.9615 1.44982 12.1731 1.53027 12.3311L1.60059 12.458C1.7769 12.7454 2.02992 12.9799 2.33203 13.1338L2.46191 13.1895C2.60569 13.2409 2.7952 13.2787 3.07715 13.3018C3.46067 13.3331 3.954 13.333 4.66504 13.333H9.99805C10.7089 13.333 11.2025 13.3331 11.5859 13.3018C11.9613 13.2711 12.1731 13.2142 12.3311 13.1338L12.458 13.0625C12.7454 12.8862 12.9799 12.6331 13.1338 12.3311L13.1895 12.2012C13.2409 12.0574 13.2787 11.8677 13.3018 11.5859C13.3331 11.2025 13.333 10.7089 13.333 9.99805V9.83203C13.333 9.46487 13.6309 9.16717 13.998 9.16699C14.3653 9.16699 14.6631 9.46476 14.6631 9.83203V9.99805C14.6631 10.6871 14.6637 11.2441 14.627 11.6943C14.5942 12.0953 14.5292 12.4565 14.3848 12.793L14.3184 12.9355C14.0529 13.4565 13.649 13.8922 13.1533 14.1963L12.9355 14.3184C12.5588 14.5103 12.1523 14.5895 11.6943 14.627C11.2441 14.6637 10.6871 14.6631 9.99805 14.6631H4.66504C3.97595 14.6631 3.41899 14.6637 2.96875 14.627C2.56821 14.5942 2.20731 14.5299 1.87109 14.3857L1.72852 14.3184C1.2074 14.0528 0.770898 13.6491 0.466798 13.1533L0.344727 12.9355C0.152758 12.5588 0.073554 12.1523 0.0361335 11.6943C-0.000636417 11.2441 7.1478e-07 10.687 7.1478e-07 9.99805ZM6.66699 9.83203V2.27051L4.46875 4.46875C4.20911 4.72839 3.78803 4.72829 3.52832 4.46875C3.26862 4.20905 3.26862 3.78802 3.52832 3.52832L6.86133 0.194336L6.96289 0.111328C7.07128 0.0391338 7.19987 9.45271e-09 7.33203 0C7.50813 8.62398e-05 7.67715 0.0699043 7.80176 0.194336L11.1357 3.52832C11.3951 3.78799 11.3952 4.20915 11.1357 4.46875C10.876 4.72845 10.454 4.72845 10.1943 4.46875L7.99707 2.27148V9.83203C7.9969 10.199 7.69904 10.4969 7.33203 10.4971C6.96487 10.4971 6.66717 10.1992 6.66699 9.83203Z",
        fill: "currentColor"
      }
    )
  }
);
const IconProfile = ({ size = 24, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M13.7569 2.44313C12.2458 0.932132 10.2369 0.0999756 8.09998 0.0999756C5.9631 0.0999756 3.95413 0.932132 2.4431 2.44313C0.932132 3.95413 0.0999756 5.9631 0.0999756 8.09998C0.0999756 10.2369 0.932132 12.2458 2.4431 13.7568C3.95413 15.2678 5.9631 16.1 8.09998 16.1C10.2369 16.1 12.2458 15.2678 13.7569 13.7568C15.2678 12.2458 16.1 10.2369 16.1 8.09998C16.1 5.9631 15.2678 3.95413 13.7569 2.44313ZM8.09998 15.1625C6.1986 15.1625 4.47054 14.4069 3.1996 13.1806C3.88785 11.0777 5.86519 9.63123 8.09998 9.63123C10.3348 9.63123 12.3121 11.0777 13.0004 13.1807C11.7294 14.4069 10.0014 15.1625 8.09998 15.1625ZM5.75623 6.34998C5.75623 5.05763 6.80763 4.00623 8.09998 4.00623C9.39232 4.00623 10.4437 5.05763 10.4437 6.34998C10.4437 7.64232 9.39232 8.69373 8.09998 8.69373C6.80763 8.69373 5.75623 7.64232 5.75623 6.34998ZM13.7044 12.3923C13.0147 10.7787 11.6605 9.55263 10.0238 9.00635C10.8457 8.40948 11.3812 7.44116 11.3812 6.34998C11.3812 4.54069 9.90926 3.06873 8.09998 3.06873C6.29069 3.06873 4.81873 4.54069 4.81873 6.34998C4.81873 7.44116 5.35426 8.40948 6.17616 9.00635C4.53948 9.55263 3.18529 10.7787 2.4956 12.3923C1.58166 11.2018 1.03748 9.71335 1.03748 8.09998C1.03748 4.20569 4.20569 1.03748 8.09998 1.03748C11.9943 1.03748 15.1625 4.20569 15.1625 8.09998C15.1625 9.71335 14.6183 11.2018 13.7044 12.3923Z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: "0.2"
      }
    )
  }
);
const IconPurchases = ({ size = 24, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M17.3117 4.92841L9.05741 0.162776C8.98615 0.121635 8.90532 0.0999756 8.82303 0.0999756C8.74075 0.0999756 8.65992 0.121635 8.58866 0.162776L0.334351 4.92841C0.263094 4.96955 0.203921 5.02872 0.162779 5.09998C0.121638 5.17123 0.0999777 5.25206 0.0999756 5.33435V14.8656C0.0999777 14.9479 0.121638 15.0287 0.162779 15.1C0.203921 15.1712 0.263094 15.2304 0.334351 15.2715L8.58866 20.0372C8.65992 20.0783 8.74075 20.1 8.82303 20.1C8.90532 20.1 8.98615 20.0783 9.05741 20.0372L17.3117 15.2715C17.383 15.2304 17.4421 15.1712 17.4833 15.1C17.5244 15.0287 17.5461 14.9479 17.5461 14.8656V5.33435C17.5461 5.25206 17.5244 5.17123 17.4833 5.09998C17.4421 5.02872 17.383 4.96955 17.3117 4.92841ZM8.82303 9.55873L5.63338 7.71716L12.9502 3.49282L16.1398 5.33435L8.82303 9.55873ZM8.82303 1.11L12.0127 2.95153L4.69588 7.17591L1.50627 5.33435L8.82303 1.11ZM1.03748 6.14622L4.22889 7.98884V12.3827C4.22889 12.507 4.27827 12.6262 4.36618 12.7141C4.45409 12.802 4.57332 12.8514 4.69764 12.8514C4.82196 12.8514 4.94119 12.802 5.02909 12.7141C5.117 12.6262 5.16639 12.507 5.16639 12.3827V8.53013L8.35428 10.3706V18.8193L1.03748 14.5949V6.14622ZM9.29178 18.8193V10.3706L16.6086 6.14626V14.5949L9.29178 18.8193Z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: "0.2"
      }
    )
  }
);
const IconLogout = ({ size = 24, className, style }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: [
      /* @__PURE__ */ jsx("mask", { id: "mask0_logout", style: { maskType: "luminance" }, maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "18", height: "18", children: /* @__PURE__ */ jsx("path", { d: "M0 0H18V18H0V0Z", fill: "white" }) }),
      /* @__PURE__ */ jsxs("g", { mask: "url(#mask0_logout)", children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M11.9882 13.7812V15.1875C11.9882 16.3525 11.0438 17.2969 9.87885 17.2969H2.81244C1.64747 17.2969 0.703064 16.3525 0.703064 15.1875V2.8125C0.703064 1.64753 1.64747 0.703125 2.81244 0.703125H9.87885C11.0438 0.703125 11.9882 1.64753 11.9882 2.8125V4.21875",
            stroke: "currentColor",
            strokeWidth: "1.25",
            strokeMiterlimit: "10",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M17.1211 9.03515H7.59375",
            stroke: "currentColor",
            strokeWidth: "1.25",
            strokeMiterlimit: "10",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M15.4134 11.3555L16.9879 9.78092C17.3998 9.36903 17.3998 8.70128 16.9879 8.28938L15.4134 6.71484",
            stroke: "currentColor",
            strokeWidth: "1.25",
            strokeMiterlimit: "10",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ] })
    ]
  }
);
export {
  IconArrowRight,
  IconChats,
  IconChevronUp,
  IconClose,
  IconCompose,
  IconHamburger,
  IconHome,
  IconImageUpload,
  IconLogout,
  IconMicrophone,
  IconProfile,
  IconPurchases,
  IconSearch,
  IconShareChat,
  IconSidebar,
  IconTrash
};
//# sourceMappingURL=ConciergeIcons.js.map
